import ICheckoutState from '@/interfaces/CheckoutState';

import { Payment } from '@/classes/Checkout/Payment';
import { Invoice } from '@/classes/Checkout/Invoice';
import { Checkout } from '@/classes/Checkout/Checkout';

export default {
  checkout: new Checkout(),
  payment: new Payment(),
  invoice: new Invoice(),
  order: null,
  contract: null,
  upsell: null,
  offerLoading: false,
  loading: false,
  targetContentLink: null,
  reRenderKey: 0,
  modalPayment: false,
  modalUpsell: false,
  orderForm: {
    template: '',
    styles: [],
    scripts: [],
  },
  enableHiddenMethods: false,
  koin: {
    activated: false,
    checked: false,
    step: '',
    installment: null,
    fraud_id: null,
  },
  creditCard: {
    filterActived: null,
    refFormActived: null,
  },
  paymentConditionIdSelected: null,
  mainPaymentCondition: null,
  secondPaymentCondition: null,
} as ICheckoutState;
